module.exports = __webpack_public_path__ + "assets/photo-icon.svg";


//////////////////
// WEBPACK FOOTER
// ./images/icons/photo-icon.svg
// module id = 810
// module chunks = 0